import type { HeroBannerCarouselItemWeb } from '@vista-digital/lumos-cms-client'
import type { HeroFilmSlidePropsApi } from '@/common/components/heroCarousel/heroCarousel.models'
import type { HeroCarouselSlideTypes } from '@/common/model_builder/blockLists/heroCarouselSlideTypes'

export const mapHeroCarouselCmsPropsToLumos = (slides: HeroCarouselSlideTypes) => {
    return slides.map(slide => {
        if (isFilmSlide(slide)) {
            return {
                filmId: slide.film.key,
                type: 'Film',
            }
        } else {
            return {
                altText: slide.image.alt,
                image: slide.image.url,
                type: 'Image',
                url: slide.url?.url,
            }
        }
    }) as HeroBannerCarouselItemWeb[]
}

const isFilmSlide = (slide: HeroCarouselSlideTypes[number]): slide is HeroFilmSlidePropsApi => {
    return 'film' in slide
}
